import {
  AfterViewInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
} from '@angular/core';

import { RxTabComponent } from '../rx-tab/rx-tab.component';
import { RxButtonModule } from '@nrwl/rx-button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RxRoleGuardModule } from '@org/rx-directives';

@Component({
  selector: 'rx-tabs',
  templateUrl: './rx-tabs.component.html',
  styleUrls: ['./rx-tabs.component.scss'],
  imports: [CommonModule, FormsModule, MatSlideToggleModule, RxButtonModule, RxRoleGuardModule],
})
export class RxTabsComponent implements OnInit, AfterViewInit {
  @ContentChildren(RxTabComponent) _tabs: QueryList<RxTabComponent>;
  @Input() selected = 0;

  @Output() selectedChange = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {}

  public onTabClicked(tab, index) {
    this.selected = index;
    this.selectedChange.emit(index);
  }
}
